module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/user/components/dictionary/nationality/edit/center-nationality-dialog.component.scss
// module id = ./src/app/modules/user/components/dictionary/nationality/edit/center-nationality-dialog.component.scss
// module chunks = main